<template>
    <div class="page">
        <!--Title/Actions-->
        <div class="page-header flex-shrink-0 bg-white border-bottom">
            <div class="d-flex justify-content-between px-md-4 px-3">
            <h3><i class="fas fa-city mr-2"></i>Notification Subscriptions</h3>
            <div>
                <router-link class="btn btn-success text-white" title="Add Subscription" :to="{ name: 'NotificationAdd', params: { id: 'new' }}"><i class="fas fa-plus"></i> Add Subscription</router-link>
            </div>
            </div>
        </div>
        <!--Table-->
        <div class="container-fluid flex-grow-1 overflow-auto px-md-4 px-3 mt-3">
            <b-table-simple bordered class="rg-table mb-5">
                <b-thead>
                <b-tr>
                    <b-th>Name</b-th>
                    <b-th>Status</b-th>
                    <b-th text-align="center" style="width: 10%;">Actions</b-th>
                </b-tr>
                </b-thead>
                <b-tbody>
                <b-tr v-for="subscription in subscriptions" v-bind:key="subscription.id">
                    <b-td>
                    {{subscription.name}}
                    </b-td>
                    <b-td>
                    Active
                    </b-td>
                    <b-td class="table-action text-center">
                    <router-link class="btn btn-link" title="Edit Group" :to="{ name: 'NotificationAdd', params: { id: subscription.id }}"><i class="fas fa-edit"></i></router-link>
                    <i class="fas fa-trash text-danger" @click.once="doDeleteSubscription(subscription)" title="Delete Subscription" ></i>
                    </b-td>
                </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'Subscriptions',
  data () {
    return {
      subscriptions: []
    }
  },
  async created () {
    await this.doLoadSubscriptions()
  },
  computed: {
  },
  methods: {
    ...mapActions('companyNotifications', ['getSubscriptions', 'deleteSubscription']),
    async doLoadSubscriptions () {
      this.subscriptions = await this.getSubscriptions()
    },
    async doDeleteSubscription (subscription) {
      if (window.confirm('Are you sure you want to delete this subscription? This action cannot be undone.')) {
        await this.deleteSubscription(subscription).then(a => {
          this.doLoadSubscriptions()
        })
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/setup/Notifications.vue